document.addEventListener("DOMContentLoaded", function(e) {
    "use strict";

    const track = (funnelId, pageId, variationId) => {

        const payload = {
            fid: funnelId,
            pid: pageId,
            vid: variationId,
            referer: document.referrer,
            currentUrl: window.location.href,
            _wpnonce: window.OPFunnelStats.nonce
        };

        fetch(window.OPFunnelStats.rest_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.OPFunnelStats.nonce,
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (!response.ok) {
                    return;
                }
                if (response.status === 204) {
                    return null;
                }
                return response;
            })
            .then((response) => {
                if (!response) {
                    return null;
                }
                return response.json();
            })
            .then((result) => {
                if (!result || !result.data) {
                    return;
                }
                window.OPFunnelStats.queried_object_id = result.data.queried_object_id;
                window.OPFunnelStats.pageview_record_id = result.data.pageview_record_id;
            })
            .catch((error) => {
                console.error(error);
                return;
            });
    }

    if (window.OPFunnelStats && window.OPFunnelStats.fid && window.OPFunnelStats.pid && window.OPFunnelStats.pid) {
        track(window.OPFunnelStats.fid, window.OPFunnelStats.pid, window.OPFunnelStats.vid);
    }
});